import { Directive, Inject, Input } from '@angular/core';
import {
  AsyncValidator,
  AbstractControl,
  ValidationErrors,
  Validators,
  NG_ASYNC_VALIDATORS
} from '@angular/forms';
import {
  VALIDATORS_CONFIGURATION_TOKEN,
  ValidatorsConfiguration
} from '../tokens';
import { Observable, of } from 'rxjs';
import { CommonService } from '@ecosure-suite/shared/utils-helpers';

@Directive({
  selector:
    // tslint:disable-next-line: directive-selector
    '[personName][formControlName],[personName][formControl],[personName][ngModel]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: PersonNameValidatorDirective,
      multi: true
    }
  ]
})
export class PersonNameValidatorDirective implements AsyncValidator {
  @Input() required = undefined;
  @Input() enabled = undefined;

  personNameValidator: { enabled: boolean; required: boolean; regex: string };

  constructor(
    @Inject(VALIDATORS_CONFIGURATION_TOKEN)
    configuration: ValidatorsConfiguration
  ) {
    this.personNameValidator = configuration.personName;
  }

  validate(
    control: AbstractControl
  ): Promise<ValidationErrors> | Observable<ValidationErrors> {
    if (this.required === undefined || this.required === null) {
      if (this.personNameValidator.required) {
        const isRequired = Validators.required(control);
        if (CommonService.isDefined(isRequired)) {
          return of(isRequired);
        }
      }
    } else {
      if (this.required) {
        const isRequired = Validators.required(control);
        if (CommonService.isDefined(isRequired)) {
          return of(isRequired);
        }
      }
    }

    if (this.enabled === undefined || this.enabled === null) {
      if (this.personNameValidator.enabled) {
        return control.value.match(new RegExp(this.personNameValidator.regex))
          ? of(null)
          : of({ personName: true });
      }
    } else {
      if (this.enabled) {
        return control.value.match(new RegExp(this.personNameValidator.regex))
          ? of(null)
          : of({ personName: true });
      }
    }

    return of(null);
  }
}
